import { render, staticRenderFns } from "./customer-detail.vue?vue&type=template&id=e6b91d82&scoped=true"
import script from "./customer-detail.vue?vue&type=script&lang=js"
export * from "./customer-detail.vue?vue&type=script&lang=js"
import style0 from "./customer-detail.vue?vue&type=style&index=0&id=e6b91d82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b91d82",
  null
  
)

export default component.exports